import React from 'react';
import styled from 'styled-components';
import { Field } from 'formik';
import PropTypes from 'prop-types';

import { mediaHelper } from 'utils';
import Colors from 'constants/Colors';
import RadioCard from './RadioCard';
import { Text, FontWeight } from '../../Text';
// import ServiceNotification from '../../Notification/ServiceNotification';

const propTypes = {
  fieldName: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func
};

const defaultProps = {
  fieldName: PropTypes.string,
  options: PropTypes.array,
  onChange: () => {}
};

const StyledRadioCard = styled(RadioCard)`
  margin-bottom: 16px;

  &:last-child {
    margin-right: 0;
    margin-bottom: 0;
  }

  ${mediaHelper.md`
    flex: 1;
    margin-right: 24px;
    margin-bottom: 0;
    max-width: 276px;
  `};
`;

const RadioCardGroupFieldContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaHelper.md`
    flex-direction: row;
  `};
`;

const RadioLabelContainer = styled.div`
  margin-bottom: 16px;
`;

const RadioLabel = styled(Text).attrs({
  weight: FontWeight.Bold
})`
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  color: ${Colors.SECONDARY_MEDIUM};
`;

// const StyledServiceNotification = styled(ServiceNotification)`
//   margin-top: 20px;
// `;

const RadioCardGroup = ({
  fieldName,
  label,
  options,
  alignTitleCenter,
  disabled,
  notificationData,
  onChange,
  ...props
}) => (
  <div {...props}>
    {label && (
      <RadioLabelContainer>
        <RadioLabel>{label}</RadioLabel>
      </RadioLabelContainer>
    )}
    <RadioCardGroupFieldContainer>
      {options.map(el => (
        <Field
          key={JSON.stringify(el.value)}
          name={fieldName}
          option={el}
          component={StyledRadioCard}
          tabIndex={el.tabIndex}
          alignTitleCenter={alignTitleCenter}
          disabled={disabled || el.disabled}
          renderBottomContent={el.renderBottomContent}
          onChange={onChange}
        />
      ))}
    </RadioCardGroupFieldContainer>
    {/* {notificationData && (
      <StyledServiceNotification
        type={notificationData.type}
        text={notificationData.text}
        link={notificationData.link}
      />
    )} */}
  </div>
);

RadioCardGroup.propTypes = propTypes;
RadioCardGroup.defaultProps = defaultProps;

export default RadioCardGroup;
